import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.el.addEventListener('click', () => {
            const container = this.el.closest('.js-modal-content-rappel');
            const date = container.querySelector('[data-date]').innerHTML;
            const titre = container.querySelector('[data-titre]').innerHTML;

            // Build the API URL
            const params = new URLSearchParams({
                date: date,
                titre: titre
            });

            // Use the REST API root from WPURLS
            let apiUrl = WPURLS.rest + 'procedeuil/v1/ical?' + params.toString();
            if (apiUrl.startsWith('/')) {
                apiUrl = window.location.origin + apiUrl;
            }
            console.log(apiUrl);

            // replace https with webcal
            //apiUrl = apiUrl.replace('https://', 'webcal://');

            // Use a real <a> element for iOS compatibility
            const a = document.createElement('a');
            a.href = apiUrl;
            a.style.display = 'none';
            a.target = '_blank'; // optional, but can help
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        });
    }
}
